
































































import Vue from "vue";

// Vuex
import { mapState } from "vuex";
import { RootState } from "@/store";

// Model
import { ModelInfo } from "@/model/communication/supportObjects/ModelInfo";
import { InstallationContent } from "@/model/data/content/InstallationContent";
import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    data() {
        return {};
    },
    props: {
        machineSerialNumber: String,
        totalQuantity: Number,
        cashType: Number,
        installations: Array,
        bagFillingPercentage: Number,
    },
    computed: {
        ...mapState({
            supportedModels: function (state: RootState): ModelInfo[] {
                return this.$store.state.application.supportedModels;
            },
        }),

        isModelInModelsXmlFile(): boolean {
            return this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber).length >= 1;
        },

        bagMaxPieces(): number {
            var res: number = -1;

            var matchedModelsCount = this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber).length;
            if (matchedModelsCount > 1)
                res = this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber && m.cashType == this.cashType)[0].bagMaxItems;
            else if (matchedModelsCount == 1) res = this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber)[0].bagMaxItems;
            return res;
        },

        hasBag(): boolean {
            var res: boolean = false;

            var matchedModelsCount = this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber).length;
            if (matchedModelsCount > 1) res = this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber && m.cashType == this.cashType)[0].hasBag;
            else if (matchedModelsCount == 1) res = this.supportedModels.filter((m: ModelInfo) => m.modelName == this.getModelFromSerialNumber)[0].hasBag;
            return res;
        },

        getModelFromSerialNumber(): string {
            var modelString: string = "";

            this.installations.forEach((inst: InstallationContent) => {
                inst.machines.forEach((machine: Machine) => {
                    if (machine.serialNumber == this.machineSerialNumber) {
                        modelString = machine.model;
                    }
                });
            });
            return modelString;
        },

        bagFullPercent(): number {
            var res: number = -1;
            if (this.bagMaxPieces != -1) res = Math.ceil((this.totalQuantity * 100) / this.bagMaxPieces);
            return res;
        },
    },
    methods: {
        getColor(bagFullPercent: number): string {
            return bagFullPercent < 50 ? "success" : bagFullPercent < 80 ? "warning" : "error";
        },
    },
});
